/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IpAddresses
 */
export interface IpAddresses {
}

/**
 * Check if a given object implements the IpAddresses interface.
 */
export function instanceOfIpAddresses(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IpAddressesFromJSON(json: any): IpAddresses {
    return IpAddressesFromJSONTyped(json, false);
}

export function IpAddressesFromJSONTyped(json: any, ignoreDiscriminator: boolean): IpAddresses {
    return json;
}

export function IpAddressesToJSON(value?: IpAddresses | null): any {
    return value;
}

